export const LOADING_POINTS = [
	{ value: 2_000 },
	{ value: 8_000, forecast: 8_000 },
	{ forecast: 12_000 },
];
